import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import Layout from "../../components/layout/Layout";
import SearchUI from "../../components/search/Search.presenter";
import { connect } from "react-redux";
import { isLoaded, isLoading } from "../../redux/action/loading";
import { searchProducts } from "../../api/products";
import modalOverflowHook from "../../common/modalOverflowHook";
import { Spinner } from "react-bootstrap";

const SearchPage = ({ isLoaded, isLoading, dummyList, loading }) => {
  const router = useRouter();
  const searchTerm = router.query.search;

  // 리스트 타입
  const [viewType, setViewType] = useState("grid");
  // 검색 리스트
  const [searchList, setSearchList] = useState({});
  // total
  const [searchedTotal, setSearchedTotal] = useState(0);
  // 로그인 모달
  const [openLoginModal, setOpenLoginModal] = useState(false);
  const modalScollHook = modalOverflowHook(openLoginModal);
  const [cateViewStats, setCateViewStats] = useState({
    community: { start: 0, last: 8 },
  });
  const [searchLoading, setSearchLoading] = useState(false);

  const moreProducts = (key) => {
    setCateViewStats({
      ...cateViewStats,
      [key]: { start: 0, last: cateViewStats[key]?.last + 8 },
    });
  };

  // 비회원 바로 구매 모달 오픈
  const handleLoginModal = () => {
    setOpenLoginModal((prev) => !prev);
  };

  // 바로 구매하기
  const purchaseDirect = (product) => () => {
    sessionStorage.setItem(
      "directOrder",
      JSON.stringify([{ ...product, cnt: 1 }])
    );
    if (!getCookie("token") && !openLoginModal) {
      handleLoginModal();
      return;
    } else {
      document.body.style.removeProperty("overflow");
      sessionStorage.setItem(
        "directOrder",
        JSON.stringify([{ ...product, cnt: 1 }])
      );
      router.push({
        pathname: "/checkout",
        query: {
          type: "direct",
        },
      });
    }
  };

  const handleListViewType = (type) => {
    if (viewType === type) {
      return;
    }
    localStorage.setItem("P_viewType", type);
    setViewType(type);
  };

  const fetchSearchedProducts = async () => {
    setSearchLoading(true);
    setSearchList({});
    setSearchedTotal(null);

    const body = {
      modes: "Search",
      ...router.query,
      searchTxt: router.query.search,
    };
    const res = await searchProducts(body);

    if (res.Code === "0000") {
      setSearchList(res.Data.Rows);
      setSearchedTotal(res.Data.Rows.total_count);
    } else {
      setSearchList({
        data: [],
        total_count: 0,
      });
    }
    setSearchLoading(false);
  };

  const moveToDetail = (id) => {
    window.open(`/esg-guide/post/${id}`);
  };

  useEffect(() => {
    if (!router.isReady) return;
    if (localStorage.getItem("P_viewType")) {
      setViewType(localStorage.getItem("P_viewType"));
    }
    if (
      router.query?.search ||
      router.query?.garo ||
      router.query?.sero ||
      router.query?.high
    ) {
      fetchSearchedProducts();
    }
  }, [router.query, router.isReady]);

  useEffect(() => {
    if (searchList.data) {
      if (Object.keys(searchList.data).length > 0) {
        let keys = [...Object.keys(searchList.data)];
        let temp = { ...cateViewStats };
        if (keys.length > 0) {
          keys.forEach((key) => {
            temp = { ...temp, [key]: { start: 0, last: 8 } };
          });
        }
        setCateViewStats(temp);
      }
      setSearchLoading(false);
    }
  }, [searchList]);

  return (
    <>
      <link rel="canonical" href="/search" />
      <Layout noBreadcrumb="d-none">
        {searchLoading && (
          <div>
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ minHeight: "500px" }}
            >
              <Spinner animation="border" role="status" />
            </div>
          </div>
        )}
        {searchList?.data && (
          <SearchUI
            router={router}
            viewType={viewType}
            handleListViewType={handleListViewType}
            searchList={searchList}
            searchTerm={searchTerm}
            dummyList={dummyList}
            purchaseDirect={purchaseDirect}
            searchedTotal={searchedTotal}
            moveToDetail={moveToDetail}
            moreProducts={moreProducts}
            cateViewStats={cateViewStats}
          />
        )}
      </Layout>
      {openLoginModal && (
        <RequestLoginModal
          handleLoginModal={handleLoginModal}
          openLoginModal={openLoginModal}
          purchaseDirect={purchaseDirect}
          product={JSON.parse(sessionStorage.getItem("directOrder"))[0]}
          cnt={1}
        />
      )}
    </>
  );
};
const mapStateToProps = (state) => ({
  dummyList: state.dummyList,
  loading: state.loading,
});

const mapDidpatchToProps = { isLoaded, isLoading };

export default connect(mapStateToProps, mapDidpatchToProps)(SearchPage);
